export const transferStates = {
  ONGOING: 'ONGOING',
  ONGOING_MISSING_DATA: 'ONGOING_MISSING_DATA',
  STARTING: 'STARTING',
  ENDED: 'ENDED',
  NOT_STARTED: 'NOT_STARTED',
  LATE_TO_START: 'LATE_TO_START',
  ENDING: 'ENDING',
  NO_TRANSFER: 'NO_TRANSFER',
}